import { useWindowSize } from "@components/window-size-provider";
import { CmsBreakPointsDefaults } from "@lib/constants";
import { useState, useEffect } from 'react';

const useResponsiveCmsSettings = (breakpoints) => {
    const { isLargeScreen, isMediumScreen, isSmallScreen } = useWindowSize();
    const [total, setTotal] = useState(6);
    const [gutter, setGutter] = useState(6);

    useEffect(() => {
        const bp = breakpoints ?? {
            desktop: {
                total: CmsBreakPointsDefaults.DESKTOP.TOTAL,
                gutter: CmsBreakPointsDefaults.DESKTOP.GUTTER
            },
            tablet: {
                total: CmsBreakPointsDefaults.TABLET.TOTAL,
                gutter: CmsBreakPointsDefaults.TABLET.GUTTER
            },
            mobile: {
                total: CmsBreakPointsDefaults.MOBILE.TOTAL,
                gutter: CmsBreakPointsDefaults.MOBILE.GUTTER
            },
        }

        if (isLargeScreen) {
            setTotal(bp.desktop.total);
            setGutter(bp.desktop.gutter);
        }

        if (isMediumScreen) {
            setTotal(bp.tablet.total);
            setGutter(bp.tablet.gutter);
        }

        if (isSmallScreen) {
            setTotal(bp.mobile.total);
            setGutter(bp.mobile.gutter);
        }
    }, [breakpoints, isLargeScreen, isMediumScreen, isSmallScreen]);

    return { total, gutter };
};

export default useResponsiveCmsSettings;
